var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"app"},[_c('v-main',[_c('router-view')],1),_c('Snackbar'),_c('span',{staticStyle:{"width":"0","height":"0"},attrs:{"id":"idoniaViewerLoadedFlag"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }